import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import KerdesTableDto from '../dto/KerdesTableDto';

class KerdesTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'kerdesTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<KerdesTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, KerdesTableDto)))
				.catch(reject);
		});
	}
}

export default new KerdesTableService();
